import type { Model } from '@patsnap/tahiti-core';
import type { SpecificationTaskCreateState } from '../types/specification-task-create';

export const SpecificationTaskCreateModel = Symbol.for('SpecificationTaskCreateModel');

export interface SpecificationTaskCreateModel extends Model<SpecificationTaskCreateState> {}
